import React from 'react';
import { inRange } from 'lodash';
import LogoMakerBriefCarousel from '@fiverr-private/variations_display/src/components/MarketplaceBrief';
import BannerWrapper from '@fiverr-private/gig_listings/src/GigCardListings/utils/BannerWrapper';
import { MEDIA_GRID_LG, MEDIA_GRID_MD } from '../utils/constants';
import { LOGO_MAKER_BANNER_ROW } from '../components/common/listings/constants';

const getLogoMakerBanner = ({
    isTouch,
    showListViewCards,
    shouldShowBanner = false,
    page,
    listingsType,
    query
}) => {
    if (!shouldShowBanner) { return null; }

    const mdMediaQueryTop = Number.parseInt(MEDIA_GRID_LG, 10),
        mdMediaQueryBottom = Number.parseInt(MEDIA_GRID_MD, 10);
    const isWindowInMDMediaQuery = inRange(window && window.innerWidth, mdMediaQueryBottom, mdMediaQueryTop);

    const cardViewBannerRow = (isWindowInMDMediaQuery ?
        LOGO_MAKER_BANNER_ROW.TABLET :
        LOGO_MAKER_BANNER_ROW.DESKTOP);

    const bannerRow = showListViewCards ? LOGO_MAKER_BANNER_ROW.MOBILE : cardViewBannerRow;

    const logoMakerBanner = (<LogoMakerBriefCarousel isTouch={isTouch}
        context={{
            page,
            listingsType,
            position: bannerRow,
            ...query && { query }
        }}
        source="marketplace"
        target="_blank"/>);

    return BannerWrapper(logoMakerBanner)({ bannerRow, className: 'logo-maker-banner' });
};

export default getLogoMakerBanner;
